import { envConfigs } from '../../../envConfigs';
import { handleServiceCall } from '../../app/util/fetch-utils';

const CATALYST_2_BRONZE_SALES_PACKAGE_ID = 'salesPackage.1116a1ab-1e8a-427a-9cda-8925b10a179e';
const CATALYST_2_SILVER_SALES_PACKAGE_ID = 'salesPackage.e5c9390a-b6f4-fc53-ea9d-76b267711674';
const CATALYST_2_GOLD_SALES_PACKAGE_ID = 'salesPackage.2ef3e7a4-4a5b-4f9f-08e5-2068959a5b33';

// lion mapping - so that we aren't storing lion keys directly in the LPS DB activity_results json blob
// questionnaireKey : lionKey
export const questionnairelionMapping = {
  '3_years_or_more': 'quest_how_soon_4',
  '17_or_younger': 'quest_age_range1',
  '18-24': 'quest_age_range2',
  '1_2_years': 'quest_years_studied_2',
  '25-34': 'quest_age_range3',
  '35-44': 'quest_age_range4',
  '3_4_years': 'quest_years_studied_3',
  '45-54': 'quest_age_range5',
  '55+': 'quest_age_range6',
  '5_years': 'quest_years_studied_5',
  absolute_beginner: 'absolute_beginner',
  agree: 'quest_likert_statements_agree',
  airline_aviation: 'quest_employment_airline',
  architecture: 'quest_employment_architecture',
  associates_degree_aa: 'quest_education_associates',
  automotive: 'quest_employment_auto',
  bachelors_degree_ba_ba_bfa: 'quest_education_bachelor',
  beginner: 'quest_beginner_prompt',
  building_construction: 'quest_employment_building',
  communicating_for_basic_needs: 'quest_skills_improve_basic',
  communicating_for_general_needs: 'quest_skills_improve_communicating_general',
  communicating_in_a_foreign_country: 'quest_skills_improve_foreign',
  communicating_in_business_meetings: 'quest_skills_improve_business_meetings',
  communicating_on_the_phone_with_individuals_and_groups: 'quest_skills_improve_communicating_phone',
  communicating_with_colleagues_and_partners: 'quest_skills_improve_communicating_colleagues',
  communicating_with_coworkers: 'quest_skills_improve_coworkers',
  communicating_with_customers: 'quest_skills_improve_customers',
  communication_at_work: 'quest_purpose_work_comm',
  confident: 'quest_skills_improve_confident',
  disagree: 'quest_likert_statements_disagree',
  doctoral_degree_phd_jd_md: 'quest_education_doctoral',
  dont_know: 'quest_skills_improve_dont_know',
  education: 'quest_employment_education',
  emergency_services: 'quest_employment_emergency',
  employee_non_management: 'quest_role_employee',
  english_is_important_for_my: 'quest_likert_statements_2',
  frequent_consistent: 'quest_skills_improve_frequent_consistent',
  for_which_specific_field_s: 'quest_employment',
  general_business: 'quest_employment_general',
  giving_academic_presentations: 'quest_skills_improve_academic_presentation',
  giving_business_presentations: 'quest_skills_improve_biz_presentations',
  giving_presentations_at_work: 'quest_skills_improve_work_presentation',
  government_the_public_sector: 'quest_employment_government',
  high_school: 'quest_education_hs',
  high_advanced_for_example_cefr: 'quest_proficiency_high_advanced',
  high_beginner_for_example_cefr: 'quest_proficiency_high_beginner',
  high_intermediate_for_example_cefr: 'quest_proficiency_high_intermediate',
  hospitality: 'quest_employment_hospitality',
  how_many_days: 'quest_skills_improve_how_many_days',
  how_many_minutes: 'quest_skills_improve_how_many_minutes',
  how_many_years_have_you: 'quest_years_studied',
  how_soon_do_you_want: 'quest_how_soon',
  improving_job_search_skills: 'quest_skills_improve_search',
  insurance_financial_services: 'quest_employment_insurance',
  in_1_year: 'quest_how_soon_3',
  in_2_years: 'quest_how_soon_2',
  in_6_months: 'quest_how_soon_1',
  it: 'quest_employment_IT',
  i_am_confident_that_i: 'quest_likert_statements_5',
  i_don_t_know: 'quest_proficiency_dontknow',
  i_don_t_know_again: 'quest_proficiency_dontknow',
  i_feel_nervous_when_i: 'quest_likert_statements_1',
  i_look_forward_to_learning: 'quest_likert_statements_4',
  i_look_forward_to_live: 'quest_likert_statements_6',
  law_justice: 'quest_employment_law',
  learning_about_culture: 'quest_skills_learning_culture',
  learning_english_will_help_me: 'quest_likert_statements_3',
  learning_interesting: 'quest_skills_improve_learning_interesting',
  less_than_1_year: 'quest_years_studied_1',
  listening: 'quest_skills_improve_listening',
  low_advanced_for_example_cefr: 'quest_proficiency_low_advanced',
  low_beginner_for_example_cefr: 'quest_proficiency_low_beginner',
  low_intermediate_for_example_cefr: 'quest_proficiency_low_intermediate',
  luxury_goods_retail: 'quest_employment_retail',
  manager_executive_or_manager_in: 'quest_role_manager',
  managing_teams_at_work: 'quest_skills_improve_managing',
  manufacturing: 'quest_employment_manufacturing',
  marketing_advertising: 'quest_employment_marketing',
  masters_degree_ma_ms_mfa_mba: 'quest_education_masters',
  medicine_health: 'quest_employment_medicine',
  military_defense: 'quest_employment_military',
  natural_sciences: 'quest_employment_science',
  neither_agree_nor_disagree: 'quest_likert_statements_neither',
  never_studied_before: 'quest_years_studied_never',
  not_applicable: 'quest_employment_na',
  oil_gas: 'quest_employment_oil',
  other: 'quest_other',
  other_explain_below: 'quest_other_explain',
  other_please_specify: 'quest_other_specify',
  pharmaceutical: 'quest_employment_pharma',
  please_rank: 'quest_skills_improve_please_rank',
  prefer_challenge: 'quest_skills_improve_prefer_challenge',
  professional_development: 'quest_purpose_professional',
  quest_translate: 'quest_translate',
  quest_how_learn: 'quest_how_learn',
  quest_how_in_school: 'quest_how_in_school',
  quest_how_software: 'quest_how_software',
  quest_how_self_study: 'quest_how_self_study',
  quest_how_in_country: 'quest_how_in_country',
  quest_how_at_home: 'quest_how_at_home',
  quest_employment_none: 'quest_employment_none',
  rate_how_strongly_you_agree: 'quest_likert_statements',
  reading: 'quest_skills_improve_reading_general',
  reading_and_writing_business_correspondence: 'quest_skills_improve_correspondence',
  reading_and_writing_business_reports: 'quest_skills_improve_reports',
  reading_and_writing_for_academic: 'quest_skills_improve_academic',
  reading_and_writing_for_professional_purposes: 'quest_skills_improve_reading',
  reading_reports_email_etc_for: 'quest_skills_improve_reading_reports',
  relocating_to_an_english: 'quest_purpose_relocate',
  school_university_administrator_executive_or: 'quest_role_school_admin',
  speaking: 'quest_skills_improve_speaking',
  strongly_agree: 'quest_likert_statements_strongly_agree',
  strongly_disagree: 'quest_likert_statements_strongly_disagree',
  student: 'quest_role_student',
  studying_easy: 'quest_skills_improve_studying_easy',
  taking_an_english_examination: 'quest_purpose_exam_prep',
  teacher_professor: 'quest_role_teacher',
  telecom: 'quest_employment_telecom',
  this_question_is_required: 'quest_required_error',
  trade_school_not_high_school: 'quest_education_trade',
  traveling_planning_travel_or_hosting_travelers: 'quest_skills_improve_travel',
  travel_for_personal_reasons: 'quest_purpose_personal_travel',
  travel_for_work: 'quest_purpose_travel_work',
  understand_everyday: 'quest_skills_improve_understand_everyday',
  understand_i_dont_know: 'quest_skills_improve_dont_know',
  understand_long_involved: 'quest_skills_improve_understand_long_involved',
  understand_main_points: 'quest_skills_improve_understand_main_points',
  understand_simple: 'quest_skills_improve_understand_simple_sent',
  university_requirements: 'quest_purpose_university',
  what_is_the_highest_level: 'quest_education',
  what_is_your_age: 'quest_age',
  what_is_your_main_purpose: 'quest_purpose',
  what_is_your_primary_topic_of_interest: 'quest_skills_improve_gaia',
  what_is_your_role_within: 'quest_role',
  what_level_of_english_proficiency: 'quest_proficiency',
  what_skills: 'quest_skills_improve_what_skills',
  which_english_skills_do_you: 'quest_skills_improve',
  writing: 'quest_skills_improve_writing',
  writing_reports_email_etc_for: 'quest_skills_improve_writing_reports',
  choose_one: 'quest_choose_one'
};

let questionnaireData = [
  {
    text: 'what_is_your_primary_topic_of_interest',
    role: 'intensity_of_need',
    required: true,
    data_qa_tags: [
      'CommunicatingForGeneralNeeds',
      'CommunicatingInBusinessMeetings',
      'CommunicatingOnThePhoneWithIndividualsAndGroups',
      'CommunicatingWithColleaguesAndPartners',
      'CommunicatingWithCustomers',
      'GivingBusinessPresentations',
      'ManagingTeamAtWork',
      'ReadingAndWritingBusinessCorrespondence',
      'ReadingAndWritingBusinessReports',
      'ReadingForProfessionalPurposes',
      'ImprovingJobSearchSkills',
      'TravelingPlanningTravelOrHostingTravelers'
    ],
    answers_by_language: [
      {
        answer: 'communicating_for_general_needs',
        languages: ['de-DE', 'en-GB', 'en-US', 'es-419', 'es-ES', 'fr-FR', 'it-IT']
      },
      {
        answer: 'communicating_in_business_meetings',
        languages: ['de-DE', 'en-GB', 'en-US', 'es-419', 'es-ES', 'fr-FR', 'it-IT']
      },
      {
        answer: 'communicating_on_the_phone_with_individuals_and_groups',
        languages: ['de-DE', 'en-GB', 'en-US', 'es-419', 'es-ES', 'fr-FR', 'it-IT']
      },
      {
        answer: 'communicating_with_colleagues_and_partners',
        languages: ['de-DE', 'en-GB', 'en-US', 'es-419', 'es-ES', 'fr-FR', 'it-IT']
      },
      {
        answer: 'communicating_with_customers',
        languages: ['de-DE', 'en-GB', 'en-US', 'es-419', 'es-ES', 'fr-FR', 'it-IT']
      },
      {
        answer: 'reading_and_writing_for_professional_purposes',
        languages: ['de-DE', 'en-GB', 'en-US', 'es-419', 'es-ES', 'fr-FR', 'it-IT']
      },
      { answer: 'giving_business_presentations', languages: ['en-GB', 'en-US'] },
      { answer: 'managing_teams_at_work', languages: ['en-GB', 'en-US'] },
      { answer: 'reading_and_writing_business_correspondence', languages: ['en-GB', 'en-US'] },
      { answer: 'reading_and_writing_business_reports', languages: ['en-GB', 'en-US'] },
      { answer: 'improving_job_search_skills', languages: ['en-GB', 'en-US'] },
      {
        answer: 'traveling_planning_travel_or_hosting_travelers',
        languages: ['de-DE', 'en-GB', 'en-US', 'es-419', 'es-ES', 'fr-FR', 'it-IT']
      },
      { answer: 'learning_about_culture', languages: ['de-DE', 'es-419', 'es-ES', 'fr-FR', 'it-IT'] }
    ],
    catalyst2: true
  },
  {
    text: 'how_many_years_have_you',
    role: 'demographic',
    required: false,
    data_qa_tags: ['NeverStudied', 'LessThanOneYear', 'OneToTwoYears', 'ThreeToFourYears', 'FiveYears'],
    answers: ['never_studied_before', 'less_than_1_year', '1_2_years', '3_4_years', '5_years'],
    non_flubu_langs: true,
    catalyst1: true,
    show_follow_on: (currentAnswer) => {
      if (!currentAnswer || !currentAnswer.length) {
        return false;
      } else {
        return currentAnswer !== 'never_studied_before';
      }
    },
    follow_on_text: 'quest_how_learn',
    follow_on_role: 'demographic',
    follow_on_required: false,
    follow_on_answers: [
      'quest_how_in_school',
      'quest_how_software',
      'quest_how_self_study',
      'quest_how_in_country',
      'quest_how_at_home',
      'other_please_specify'
    ],
    follow_on_other_please_specify: true,
    follow_on_select: true
  },
  {
    text: 'what_skills',
    post_text: 'please_rank',
    role: 'intensity_of_need',
    required: false,
    data_qa_tags: ['Reading', 'Speaking', 'Listening', 'Writing'],
    answers: ['reading', 'speaking', 'listening', 'writing'],
    ranked: true,
    catalyst2: true
  },
  {
    text: 'what_level_of_english_proficiency',
    post_text: 'choose_one',
    role: 'intensity_of_need',
    data_qa_tags: [
      'UnderstandSimple',
      'UnderstandEveryday',
      'UnderstandMainPoints',
      'UnderstandLongInvolved',
      'UnderstandIDontKnow'
    ],
    answers: [
      'understand_simple',
      'understand_everyday',
      'understand_main_points',
      'understand_long_involved',
      'understand_i_dont_know'
    ],
    required: false,
    catalyst2: true
  },
  {
    text: 'frequent_consistent',
    post_text: 'how_many_days',
    role: 'intensity_of_need',
    slider: true,
    step_size: 1,
    required: false,
    data_qa_tags: ['Value1', 'Value2', 'Value3', 'Value4', 'Value5', 'Value6', 'Value7'],
    answers: ['1', '2', '3', '4', '5', '6', '7'],
    catalyst2: true,
    show_follow_on: () => true,
    follow_on_text: 'how_many_minutes',
    follow_on_role: 'intensity_of_need',
    follow_on_slider: true,
    follow_on_step_size: 10,
    follow_on_required: false,
    follow_on_data_qa_tags: [
      'Value10',
      'Value20',
      'Value30',
      'Value40',
      'Value50',
      'Value60',
      'Value70',
      'Value80',
      'Value90',
      'Value100',
      'Value110',
      'Value120'
    ],
    follow_on_answers: ['10', '20', '30', '40', '50', '60', '70', '80', '90', '100', '110', '120'],
    follow_on_other_please_specify: false
  },
  {
    text: 'what_is_your_main_purpose',
    post_text: 'choose_one',
    role: 'product_recommendation',
    required: true,
    catalyst2_required_override: false,
    data_qa_tags: [
      'CommunicationAtWork',
      'TravelForWork',
      'TakingAnEnglishExamination',
      'UniversityRequirements',
      'RelocatingToAnEnglish',
      'ProfessionalDevelopment',
      'TravelForPersonalReasons',
      'OtherExplainBelow'
    ],
    answers: [
      'communication_at_work',
      'travel_for_work',
      'taking_an_english_examination',
      'university_requirements',
      'relocating_to_an_english',
      'professional_development',
      'travel_for_personal_reasons',
      'other_explain_below'
    ],
    other_please_specify: true,
    non_flubu_langs: false,
    catalyst1: true,
    catalyst2: true
  },
  {
    text: 'for_which_specific_field_s',
    role: 'product_recommendation',
    required: true,
    data_qa_tags: [
      'QuestEmploymentNone',
      'AirlineAviation',
      'Architecture',
      'Automotive',
      'BuildingConstruction',
      'GeneralBusiness',
      'Education',
      'EmergencyServices',
      'GovernmentThePublicSector',
      'Hospitality',
      'InsuranceFinancialServices',
      'It',
      'LawJustice',
      'Manufacturing',
      'MarketingAdvertising',
      'MedicineHealth',
      'MilitaryDefense',
      'NaturalSciences',
      'OilGas',
      'Pharmaceutical',
      'LuxuryGoodsRetail',
      'Telecom',
      'OtherPleaseSpecify'
    ],
    answers: [
      'quest_employment_none',
      'airline_aviation',
      'architecture',
      'automotive',
      'building_construction',
      'general_business',
      'education',
      'emergency_services',
      'government_the_public_sector',
      'hospitality',
      'insurance_financial_services',
      'it',
      'law_justice',
      'manufacturing',
      'marketing_advertising',
      'medicine_health',
      'military_defense',
      'natural_sciences',
      'oil_gas',
      'pharmaceutical',
      'luxury_goods_retail',
      'telecom',
      'other_please_specify'
    ],
    select: true,
    other_please_specify: true,
    catalyst1: true,
    non_flubu_langs: false
  },
  {
    text: 'what_level_of_english_proficiency',
    role: 'intensity_of_need',
    required: true,
    data_qa_tags: [
      'IDontKnow',
      'LowBeginnerForExampleCefr',
      'HighBeginnerForExampleCefr',
      'LowIntermediateForExampleCefr',
      'HighIntermediateForExampleCefr',
      'LowAdvancedForExampleCefr',
      'HighAdvancedForExampleCefr'
    ],
    answers: [
      'i_don_t_know',
      'low_beginner_for_example_cefr',
      'high_beginner_for_example_cefr',
      'low_intermediate_for_example_cefr',
      'high_intermediate_for_example_cefr',
      'low_advanced_for_example_cefr',
      'high_advanced_for_example_cefr'
    ],
    catalyst1: true,
    non_flubu_langs: true
  },
  {
    text: 'how_soon_do_you_want',
    role: 'intensity_of_need',
    required: true,
    data_qa_tags: ['IDontKnow', 'InSixMonths', 'InOneYear', 'InTwoYears', 'ThreeYearsOrMore'],
    answers: ['i_don_t_know', 'in_6_months', 'in_1_year', 'in_2_years', '3_years_or_more'],
    catalyst1: true,
    non_flubu_langs: true
  },
  {
    text: 'which_english_skills_do_you',
    role: 'intensity_of_need',
    required: false,
    data_qa_tags: [
      'ReadingReportsEmailEtcFor',
      'WritingReportsEmailEtcFor',
      'CommunicatingInBusinessMeetings',
      'GivingPresentationsAtWork',
      'CommunicatingWithCoworkers',
      'CommunicatingWithCustomers',
      'ReadingAndWritingForAcademic',
      'GivingAcademicPresentations',
      'CommunicatingInAForeignCountry',
      'CommunicatingForBasicNeeds',
      'OtherExplainBelow'
    ],
    answers: [
      'reading_reports_email_etc_for',
      'writing_reports_email_etc_for',
      'communicating_in_business_meetings',
      'giving_presentations_at_work',
      'communicating_with_coworkers',
      'communicating_with_customers',
      'reading_and_writing_for_academic',
      'giving_academic_presentations',
      'communicating_in_a_foreign_country',
      'communicating_for_basic_needs',
      'other_explain_below'
    ],
    select: true,
    other_please_specify: true,
    catalyst1: true,
    non_flubu_langs: true
  },
  {
    text: 'rate_how_strongly_you_agree',
    role: 'data_analytics',
    required: false,
    data_qa_tags: [
      'IFeelNervousWhenI',
      'EnglishIsImportantForMy',
      'LearningEnglishWillHelpMe',
      'ILookForwardToLive',
      'IAmConfidentThatI',
      'ILookForwardToLearning'
    ],
    answers: [
      'i_feel_nervous_when_i',
      'english_is_important_for_my',
      'learning_english_will_help_me',
      'i_look_forward_to_live',
      'i_am_confident_that_i',
      'i_look_forward_to_learning'
    ],
    scaleHeadings: [
      'not_applicable',
      'strongly_disagree',
      'disagree',
      'neither_agree_nor_disagree',
      'agree',
      'strongly_agree'
    ],
    catalyst1: true,
    non_flubu_langs: true
  },
  {
    text: 'rate_how_strongly_you_agree',
    role: 'data_analytics',
    required: false,
    data_qa_tags: [
      'IFeelNervousWhenI',
      'EnglishIsImportantForMy',
      'IAmConfidentThatI',
      'PreferChallenge',
      'LearningInteresting',
      'StudyingEasy',
      'ILookForwardToLive'
    ],
    answers: [
      'i_feel_nervous_when_i',
      'english_is_important_for_my',
      'i_am_confident_that_i',
      'prefer_challenge',
      'learning_interesting',
      'studying_easy',
      'i_look_forward_to_live'
    ],
    scaleHeadings: [
      'not_applicable',
      'strongly_disagree',
      'disagree',
      'neither_agree_nor_disagree',
      'agree',
      'strongly_agree'
    ],
    catalyst2: true
  },
  {
    text: 'absolute_beginner',
    role: 'demographic',
    statement: true,
    required: false,
    data_qa_tags: ['AbsoluteBeginner'],
    answers: ['beginner'],
    catalyst1: true,
    catalyst2: true,
    non_flubu_langs: true,
    alternateNextButtonLabel: 'quest_beginner_take_the_test_button',
    alternatePreviousButtonLabel: 'quest_beginner_skip_the_test_button',
    skipAssessmentForNovice: true,
    requiresPlacementTestAvailable: true
  }
];

const fluency_builder_languages = ['de-DE', 'en-GB', 'en-US', 'es-419', 'es-ES', 'fr-FR', 'it-IT'];

const languages_with_placement_tests = ['de-DE', 'en-US', 'en-GB', 'es-ES', 'es-419', 'fr-FR'];

export const getQuestionnaireData = (learningLanguage, productRights, showSkipPlacementTest) => {
  let hasCatalyst2 = false;
  if (productRights) {
    productRights.forEach((productRight) => {
      if (
        productRight.salesPackageId === CATALYST_2_BRONZE_SALES_PACKAGE_ID ||
        productRight.salesPackageId === CATALYST_2_SILVER_SALES_PACKAGE_ID ||
        productRight.salesPackageId === CATALYST_2_GOLD_SALES_PACKAGE_ID
      ) {
        hasCatalyst2 = true;
      }
    });
  }
  const isLearningFluencyBuilderLanguage = fluency_builder_languages.includes(learningLanguage);
  let viewNumber = 0;
  let filteredQuestionnaire = [];
  // handle Cat1/Cat2 and Fluency Builder questionnaire differences
  questionnaireData.forEach((questionAndAnswers) => {
    if (hasCatalyst2 && questionAndAnswers.catalyst2_required_override !== undefined) {
      //not controlling beginner question
      questionAndAnswers.required = questionAndAnswers.catalyst2_required_override;
    }
    let includeQuestion = false;

    if (!questionAndAnswers.skipAssessmentForNovice) {
      // ALL QUESTIONS EXCEPT skipAssessmentForNovice
      if (hasCatalyst2) {
        // LEARNER HAS CAT2 LICENSE
        if (isLearningFluencyBuilderLanguage && questionAndAnswers.catalyst2) {
          includeQuestion = true;
        }
        if (!isLearningFluencyBuilderLanguage && questionAndAnswers.non_flubu_langs) {
          includeQuestion = true;
        }
      } else {
        // LEARNER DOES NOT HAVE CAT2 LICENSE
        if (questionAndAnswers.catalyst1) {
          if (learningLanguage === 'en-US' || learningLanguage === 'en-GB') {
            includeQuestion = true;
          } else if (questionAndAnswers.non_flubu_langs) {
            includeQuestion = true;
          }
        }
      }
    } else {
      // ONLY skipAssessmentForNovice
      if (showSkipPlacementTest) {
        // controlled from QuestionsAndAnswers.jsx. Question is included if:
        // 1. ego org learnerConfigs.skipPlacementTest === true
        // 2. ego learner userInfo.targetLanguage.howChosen !== 'admin' ie. the cefr level was not preset by admin
        includeQuestion = true;
      }
    }

    if (
      questionAndAnswers.requiresPlacementTestAvailable &&
      languages_with_placement_tests.indexOf(learningLanguage) === -1
    ) {
      includeQuestion = false;
    }

    if (includeQuestion) {
      if (questionAndAnswers.answers_by_language) {
        questionAndAnswers.answers = questionAndAnswers.answers_by_language
          .filter((answerData) => {
            return answerData.languages.includes(learningLanguage);
          })
          .map((filteredAnswerData) => {
            return filteredAnswerData.answer;
          });
      }
      questionAndAnswers.view = viewNumber++;
      filteredQuestionnaire.push(questionAndAnswers);
    }
  });
  return filteredQuestionnaire;
};

const postProcessAnswers = (rawData) => {
  // Lift all answers of the form ..._other up to be their own questions
  for (var question in rawData) {
    if (rawData.hasOwnProperty(question)) {
      // If question value is an object
      if (rawData[question] !== null && typeof rawData[question] === 'object') {
        const answerNames = Object.keys(rawData[question]);
        for (var i = 0; i < answerNames.length; i++) {
          const answerName = answerNames[i];
          if (answerName.endsWith('_other')) {
            rawData[answerName] = rawData[question][answerName];
            delete rawData[question][answerName];
          }
        }
      }
    }
  }

  // Ensure that for_which_specific_field_s exists, even for non-assessment tested languages
  if (!rawData.hasOwnProperty('for_which_specific_field_s')) {
    rawData['for_which_specific_field_s'] = {};
  }

  return rawData;
};

export const saveQuestionnaireData = (questionnaireData, activityId, token) => {
  const lpsUrl = envConfigs.lpsApiHost + '/api/activity_results/questionnaire';
  const postBody = {
    activity_id: activityId,
    result: postProcessAnswers(questionnaireData)
  };
  return fetch(lpsUrl, {
    method: 'POST',
    body: JSON.stringify(postBody),
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + token,
      Accept: 'application/json',
      'Cache-Control': 'no-store, no-cache, must-revalidate, post-check=0, pre-check=0',
      Pragma: 'no-cache'
    }
  }).then((response) => {
    return handleServiceCall(response);
  });
};



// WEBPACK FOOTER //
// ./src/modules/questionnaire/services/questionnaire-helpers.js